import { watch } from 'vue'

export function showViaAppModal(appModal, openArgs) {
  return new Promise((resolve) => {
    let settled = false
    let stop = null

    const finish = () => {
      if (settled) {
        return
      }
      settled = true
      if (stop) {
        stop()
      }
      resolve()
    }

    stop = watch(
      () => appModal.isActive,
      (isActive) => {
        if (!isActive) {
          finish()
        }
      },
    )

    appModal.open(openArgs).finally(finish)
  })
}
